<template>
  <v-dialog v-model="popSigninMenu" max-width="350px">
    <div slot="activator">
      <v-list color="white" two-line>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon x-large color="secondary">lock_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="primary--text">Sign in</v-list-tile-title>
            <v-list-tile-sub-title>Sign in to view your projects and devices </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <v-list-tile-action>
            <v-icon color="secondary">arrow_forward</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </div>
    <v-card>
      <v-toolbar color="white" class="elevation-0 iotyblack--text">
        <v-toolbar-title>Sign in</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <form @submit.prevent="onSignin">
            <v-layout row>
              <v-flex xs12>
                <v-text-field v-model="email" label="E-mail" :rules="[rules.required, rules.email]" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-if="!forgot" row>
              <v-flex xs12>
                <v-text-field v-model="password" label="Password" type="password" :rules="[rules.required]"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <div v-if="gError" class="mt-2 error--text">{{ gError.message }}</div>
                <v-btn v-if="!forgot" type="submit" class="primary white--text mt-4" flat block :disabled="authLoading" :loading="authLoading">
                  <span>Sign in</span>
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
                <v-btn class="mt-0" flat outline block color="primary" v-if="forgot" @click="onResetPassword()">Reset my password</v-btn>
                <v-btn class="mt-3" flat block color="error" v-if="forgot" @click="forgot=false">Cancel</v-btn>
              </v-flex>
            </v-layout>
            <v-btn class="mt-3 iotygrey9--text" flat block v-if="!forgot" @click="forgot=true">I forgot my password</v-btn>
          </form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      forgot: false,
      popSigninMenu: false,
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  computed: {
    authLoading() {
      return this.$store.state.auth.authLoading
    },
    gError() {
      return this.$store.state.auth.gError
    }
  },
  methods: {
    popSigninClicked() {
      this.forgot = false
      this.popSigninMenu = true
    },
    onResetPassword() {
      this.$store.dispatch("resetPassword", this.email)
    },
    onSignin() {
      this.$store.dispatch("signUserIn", {
        email: this.email,
        password: this.password
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Signin.vue